import React, { useContext, useEffect, useState } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-navigation";
import BetterAlert from "../../components/BetterAlert";
import Button from "../../components/Button";
import ButtonBack from "../../components/ButtonBack";
import Loading from "../../components/Loading";
import MessageTypeModal from "../../components/MessageTypeModal";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import { GlobalContext } from "../../contexts/global";
import Validade from "../../helpers/validate";
import { ForgotPassword } from "../../services/Api/login";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";

export default function ResetPassword({ navigation }) {
  const { tokenApi } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const { setLoading, loading } = useContext(GlobalContext);
  const [payloadResetPassoword, setPayloadResetPassword] = useState();
  const [showAlert, setShowAlert] = useState({});
  const [showMessageModal, setShowMessageModal] = useState(false);

  const resetPasswordApi = (email, messageType = 0) => {
    setLoading({show: true, message: "Enviando código de verificação"});
    ForgotPassword(email, tokenApi, messageType)
      .then((response) => {
        if (response.statusCode) {
          setPayloadResetPassword({
            codeVerification: response.confirmationNumber,
            idUser: response.idUser,
            nextPage: "ChangePassword",
            email: email,
          });
        } else {
          let msgErro = response.reason;
          setShowAlert({
            type: "warning",
            title: "Atenção",
            message: msgErro,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        }
      })
      .catch((error) => {
        let { statusCode, reason } = error;
        setShowAlert({
          type: "alert",
          title: "Atenção",
          message: statusCode === 0 ? "Usuário não encontrado." : reason,
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      }).finally(()=>{
        setLoading({show: false, message: "Reenviando código de verificação"});
      });
  };

  const onPressMessage = (messageType) => {
    setShowMessageModal(false);
    resetPasswordApi(email, messageType);
  };

  useEffect(() => {
    if (payloadResetPassoword)
      navigation.navigate("CodeVerification", { ...payloadResetPassoword });
  }, [payloadResetPassoword]);

  if (loading.show) return <Loading message={loading.message} />;

  return (
    <SafeAreaView style={styles.container}>
      <ButtonBack navigation={navigation} />
      <Image
        source={require("../..//../assets/images/logo-viamais-login.png")}
        style={styles.logoPequeno}
      />
      <Text style={styles.inputLogin}>Esqueci minha senha</Text>

      <CaixaTextoInputIcone
        iconName={"email-outline"}
        placeholderInput={"Email"}
        keyboardType={"email-address"}
        onChangeTextInput={(email) => setEmail(email)}
        value={email}
        textContentType={"emailAddress"}
      />

      <Text style={styles.instructions}>
        {"Você receberá um código de verificação em seguida."}
      </Text>

      <Button
        textoBotao={"Enviar"}
        estilo={styles.button}
        onPress={() => {
          if (!Validade.Email(email.trim())) {
            setShowAlert({
              type: "warning",
              title: "Atenção",
              message:
                "Você digitou seu email corretamente? Isso não me parece um email.",
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
          } else {
            setShowMessageModal(true);
          }
        }}
      />

      <View style={{ justifyContent: "flex-end" }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
          <View>
            <Text style={{ width: 50, textAlign: "center" }}>Ou</Text>
          </View>
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
        </View>
        <Text
          style={{
            fontSize: Fonts.FONT_SIZE_16,
            textAlign: "center",
            marginTop: 15,
          }}
        >
          Lembrou a senha?{" "}
        </Text>
        <Text
          onPress={() => navigation.navigate("Login")}
          style={{
            fontSize: Fonts.FONT_SIZE_22,
            textAlign: "center",
            marginTop: 1,
            fontWeight: "bold",
          }}
        >
          Faça Login
        </Text>
      </View>
      <BetterAlert {...showAlert} />
      <MessageTypeModal
        show={showMessageModal}
        onPressMessage={(messageValue) => onPressMessage(messageValue)}
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  logoPequeno: {
    marginBottom: 10,
    resizeMode: "contain",
    width: 240,
    height: 74,
  },
  inputLogin: {
    fontSize: Fonts.FONT_SIZE_25,
    textAlign: "center",
    marginBottom: 20,
    // fontWeight: 'bold',
    color: Colors.WELCOME_TEXT,
  },
  container: {
    flex: 1,
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.WHITE,
  },
  button: {
    width: "70%",
  },
  instructions: {
    fontSize: Fonts.FONT_SIZE_14,
    textAlign: "center",
    padding: 16,
    marginTop: -24,
  },
});
